import type { Content } from "@prismicio/client"
import type { SliceComponentProps } from "@prismicio/react"

import { Hero, imgixGrayscaleFilter, HeroWithDropdown } from "@bounce/web-components"

/**
 * Props for `Hero`.
 */
export type HeroSliceProps = SliceComponentProps<Content.HeroSlice>

/**
 * Component for "Hero" Slices.
 */
const HeroSlice = ({ slice }: HeroSliceProps): React.JSX.Element => {
  const { grayscale, ...props } = slice.primary
  const imgixParams = grayscale ? imgixGrayscaleFilter : undefined

  // Using a type assertion to overcome the type mismatch
  // This is safe because we know the variation exists in model.json
  if ((slice.variation as string) === "heroDropdown") {
    return <HeroWithDropdown {...props} imgixParams={imgixParams} />
  }

  // Default variation
  return <Hero {...props} imgixParams={imgixParams} />
}

export default HeroSlice
